/** Returns label for an article button link based on article params.
 * if `link.title` is specified, it returns `link.title.
 * Otherwise returns `labelWatch` for video article or `labelRead` for other option.
 *
 * @returns string, label for an article button link.
 */
export var getLinkLabel = function getLinkLabel(_ref) {
  var isVideoArticle = _ref.isVideoArticle,
    labelRead = _ref.labelRead,
    labelWatch = _ref.labelWatch,
    link = _ref.link;
  if (link !== null && link !== void 0 && link.title) {
    return link.title;
  }
  return isVideoArticle ? labelWatch : labelRead;
};
//# sourceMappingURL=getLinkLabel.js.map